import type { ComponentStyleConfig } from '@chakra-ui/theme';

const NumberInput: ComponentStyleConfig = {
  variants: {
    outline: {
      field: {
        borderRadius: 'lg',
        borderColor: '#D0D0D0',
        color: 'black',
        fontSize: '14px',
        rounded: '4px',
        _focus: {
          shadow: 'none',
        },
        _disabled: {
          bg: '#F5F5F6',
          color: 'gray.700',
          opacity: '1',
        },
        _placeholder: {
          color: 'gray.700',
          fontWeight: '300',
          fontSize: 'inherit',
        },
        _invalid: {
          shadow: 'none',
        },
      },
      addon: {
        bg: 'transparent',
      },
      element: {
        h: 'full',
      },
    },
    merge: {
      field: {
        _disabled: {
          border: 'none',
        },
      },
    },
  },

  sizes: {
    md: {
      field: {
        h: '34px',
      },
    },
    xl: {
      field: {
        h: '56px',
        px: '6',
      },
    },
  },

  defaultProps: {
    focusBorderColor: 'brand.500',
    size: 'md',
    errorBorderColor: 'critical.500',
  },
};

export default NumberInput;
